import AxiosConfig from '@/config/axios-config'

export const EmpresaAPI = {

  listar (pagina, filtro) {
    return AxiosConfig.jalekoAPI().get('/admin/empresas',
      {
        params: {
          page: pagina
        }
      }).then(response => response.data)
  }

}

export default EmpresaAPI
